import { Component } from "react"
import PropTypes from "prop-types"
import clone from "lodash/clone"
import find from "lodash/find"
import filter from "lodash/filter"

import AuthenticationTestEnsureTokenDoesNotExpire from "partners/components/authentication_test/token_not_expire"
import AuthenticationTestRefreshAccessToken from "partners/components/authentication_test/refresh_token"
import AuthenticationTestRetrieveAuthCode from "partners/components/authentication_test/retrieve_auth_code"
import AuthenticationTestRetrieveUserInfo from "partners/components/authentication_test/retrieve_user_info"
import AuthenticationTestRequestToken from "partners/components/authentication_test/request_token"

export default class AuthenticationTest extends Component {
  constructor(props) {
    super(props)
    const statuses = {
      retrieveAuthCode: "",
      requestToken: "",
      retrieveUserInfo: "",
    }
    if (this.props.service.oauth_use_refresh_token) {
      statuses.refreshAccessToken = ""
      statuses.tokenNotExpire = ""
    }
    this.state = {
      statuses,
      combinedStatus: "",
      isShowing: this.props.activation ? true : false,
      auth: this.props.activation,
      authenticityToken: this.props.authenticity_token,
    }
    this.ensureTokenDoesNotExpire = this.ensureTokenDoesNotExpire.bind(this)
    this.refreshAccessToken = this.refreshAccessToken.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  UNSAFE_componentWillMount() {
    this.testStatusListener = window.addEventListener(
      "statusReceived",
      event => {
        const statuses = clone(this.state.statuses)
        let combinedStatus = ""

        statuses[event.detail.componentKey] = event.detail.componentStatus

        if (find(statuses, value => value === "failing")) {
          combinedStatus = "failing"
        } else if (
          filter(statuses, value => value === "passing").length ===
          Object.keys(statuses).length
        ) {
          combinedStatus = "passing"
        }
        this.setState({ statuses, combinedStatus })
      }
    )
  }

  componentWillUnmount() {
    window.removeEventListener("statusReceived", this.testStatusListener)
  }

  refreshAccessToken() {
    if (this.props.service.oauth_use_refresh_token) {
      return (
        <AuthenticationTestRefreshAccessToken
          path={this.props.refresh_token_path}
          service={this.props.service}
          authenticityToken={this.state.authenticityToken}
        />
      )
    }
    return null
  }

  ensureTokenDoesNotExpire() {
    if (this.props.service.oauth_use_refresh_token) {
      return (
        <AuthenticationTestEnsureTokenDoesNotExpire
          path={this.props.refresh_token_path}
          service={this.props.service}
          authenticityToken={this.state.authenticityToken}
        />
      )
    }
    return null
  }

  toggle() {
    this.setState({ isShowing: !this.state.isShowing })
  }

  retrieveAuthCode() {
    return (
      <AuthenticationTestRetrieveAuthCode
        {...this.state}
        authenticityToken={this.state.authenticityToken}
        path={this.props.activation_path}
        service={this.props.service}
      />
    )
  }

  requestToken() {
    return (
      <AuthenticationTestRequestToken
        code={this.props.activation.code}
        authenticityToken={this.state.authenticityToken}
        path={this.props.request_token_path}
        service={this.props.service}
      />
    )
  }

  retrieveUserInfo() {
    return (
      <AuthenticationTestRetrieveUserInfo
        code={this.props.activation.code}
        authenticityToken={this.state.authenticityToken}
        path={this.props.retrieve_user_info_path}
        service={this.props.service}
      />
    )
  }

  render() {
    let titleText = "Authentication tests pending."
    if (this.state.combinedStatus === "failing") {
      titleText = "Authentication tests failed."
    } else if (this.state.combinedStatus === "passing") {
      titleText = "Authentication tests successful."
    }
    return (
      <div className={`publish-item heading ${this.state.combinedStatus}`}>
        <header>{titleText}</header>
        {this.state.isShowing ? this.retrieveAuthCode() : null}
        {this.state.isShowing ? this.requestToken() : null}
        {this.state.isShowing ? this.retrieveUserInfo() : null}
        {this.state.isShowing ? this.refreshAccessToken() : null}
        {this.state.isShowing ? this.ensureTokenDoesNotExpire() : null}
      </div>
    )
  }
}

AuthenticationTest.propTypes = {
  authenticity_token: PropTypes.string.isRequired,
  activation: PropTypes.object,
  activation_path: PropTypes.string.isRequired,
  refresh_token_path: PropTypes.string.isRequired,
  request_token_path: PropTypes.string.isRequired,
  retrieve_user_info_path: PropTypes.string.isRequired,
  service: PropTypes.object.isRequired,
}
